import { render, staticRenderFns } from "./page7.vue?vue&type=template&id=6dd09720&scoped=true&"
import script from "./page7.vue?vue&type=script&lang=js&"
export * from "./page7.vue?vue&type=script&lang=js&"
import style0 from "./page7.vue?vue&type=style&index=0&id=6dd09720&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dd09720",
  null
  
)

export default component.exports